import React from 'react';
import './ThemeSelector.css';

interface ThemeSelectorProps {
  theme: 'light' | 'dark' | 'nord';
  onCycle: () => void;
}

const ThemeSelector: React.FC<ThemeSelectorProps> = ({ theme, onCycle }) => {
  const themeConfig = {
    light: { icon: '☀️', label: 'Light', color: '#4dd4ac' },
    dark: { icon: '🌙', label: 'Dark', color: '#58a6ff' },
    nord: { icon: '❄️', label: 'Nord', color: '#88C0D0' }
  };

  const current = themeConfig[theme];

  return (
    <button
      className={`theme-selector theme-${theme}`}
      onClick={onCycle}
      aria-label="Cycle theme"
      title={`Current: ${current.label} (click to change)`}
    >
      <div className="theme-selector-content">
        <span className="theme-icon">{current.icon}</span>
        <span className="theme-label">{current.label}</span>
      </div>
    </button>
  );
};

export default ThemeSelector;
